import { useMemo } from 'react';
import { Events, tracking } from '@lib';
import HourButton from './HourButton';
import { getButtonProperties } from './utils';
import { useFilters } from '../useFilters';

export default function HoursButtonGrid(): JSX.Element {
  const { hour, setHour, timeOfDay } = useFilters();
  const buttonProperties = useMemo(
    () => getButtonProperties(timeOfDay),
    [timeOfDay],
  );

  function handleClick(newHour: number) {
    tracking.trackEvent(Events.FILTER_BY_HOUR, { Time: newHour });

    if (newHour === hour) {
      return setHour(null);
    }

    setHour(newHour);
  }

  return (
    <div className="grid grid-cols-3 gap-2">
      {buttonProperties.map(({ text, value }) => (
        <HourButton key={value} value={value} onClick={handleClick}>
          {text}
        </HourButton>
      ))}
    </div>
  );
}
